import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IProjectTypeSelector} from "../../models/common";

@Component({
  selector: 'edsng-collections',
  templateUrl: './collections.component.html',
  styleUrls: [
    './collections.component.css'
  ]
})
export class CollectionsComponent {
  @Input() root: boolean = false;
  @Input() recursiveMenu: IProjectTypeSelector[] = [];
  @Output() selectItemMenu: EventEmitter<IProjectTypeSelector> = new EventEmitter<IProjectTypeSelector>();
  @Input() lastSelected: IProjectTypeSelector = null;


  /**
   * Funzione che viene richiamata al click su una delle collezioni selezionate
   */
  selectItem(event: any, item: IProjectTypeSelector) {
    event.stopPropagation();
    this.selectSubItem(item);
  }

  selectSubItem(item: IProjectTypeSelector) {
    // this.lastSelected = item;
    if (this.selectItemMenu && item) {
      this.selectItemMenu.emit(item);
    }
  }
}
